/**
 * @description
 */

import './iframe.scss';

import React, { useLayoutEffect, useEffect, useState, useRef, useMemo } from 'react';
import { If, Loading } from 'common/src/components';
import { USEQuery } from '@umu/umu-util';

interface IProps extends Omit<React.IframeHTMLAttributes<any>, 'id' | 'url'> {
    id?: string;
    url: string;
    topOffset?: string | number;
    uiOption?: {
        isHideLoadingIndicator: boolean; // 是否对onload等默认做loading
        isShowWhenPageLoading: boolean; // 是否在loading过程中隐藏
    };
    onLoad?: () => void;
    onDestory?: () => void;
}
export default function Iframe(props: IProps) {
    const [isLoading, setIsLoading] = useState(true);

    const elRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        return () => {
            onDestory();
        };
    }, []);

    useLayoutEffect(() => {
        bindEvents();
    }, []);

    const bindEvents = () => {
        const el = elRef.current;
        if (!el) {
            return;
        }
        el.addEventListener('load', onIframeLoaded, false);
    };

    const onIframeLoaded = () => {
        setIsLoading(false);
        if (props.onLoad) {
            props.onLoad();
        }
    };

    const onDestory = () => {
        const el = elRef.current;
        if (!el) {
            return;
        }

        el.removeEventListener('load', onIframeLoaded, false);

        if (props.onDestory) {
            props.onDestory();
        }
    };

    // shouldComponentUpdate(nextProps, nextState) {
    //     let isUpdate = false;
    //     if (this.state.iframeHeight != nextState.iframeHeight
    //         || this.state.iframeWidth != nextState.iframeWidth) {
    //         isUpdate = true;
    //     }

    //     if (this.state.loading != nextState.loading) {
    //         isUpdate = true;
    //     }

    //     if (this.props.url !== nextProps.url) {
    //         this.setState({
    //             loading: true
    //         });
    //         isUpdate = true
    //     }

    //     return isUpdate;
    // }

    const render = () => {
        const {
            url,
            topOffset: topOffsetValue = 0,
            uiOption,
            onLoad: _onLoad,
            onDestory: _onDestory,
            ...otherProps
        } = props;
        const topOffset = typeof topOffsetValue === 'number' ? `${topOffsetValue}px` : topOffsetValue;

        if (!url) {
            return null;
        }

        // 在 use 环境时对iframe的url进行标识注入
        const newUrl = useMemo(() => {
            let newUrl: URL;
            try {
                newUrl = new URL(url);
            } catch (_) {
                newUrl = new URL(url, window.location.origin);
            }

            if ((window as any).isInUSE) {
                if (!newUrl.searchParams.has(USEQuery)) {
                    newUrl.searchParams.append(USEQuery, '1');
                }
            }
            return newUrl.toString();
        }, [url, (window as any).isInUSE]);

        const height = `calc(100vh - ${topOffset})`;

        const visibility: React.CSSProperties['visibility'] = uiOption?.isShowWhenPageLoading
            ? 'visible'
            : isLoading
            ? 'hidden'
            : 'visible';
        const style = {
            display: 'block',
            visibility,
            height,
        };
        return (
            <div className="iframe-wrapper">
                {!props.uiOption?.isHideLoadingIndicator ? (
                    <If condition={isLoading}>
                        <div className="iframe-wrapping-loading opacity show">
                            <Loading />
                        </div>
                    </If>
                ) : null}
                <iframe
                    id={props.id || 'iframe-id'}
                    className="iframe"
                    width={'100%'}
                    src={newUrl}
                    style={style}
                    frameBorder={0}
                    allowFullScreen={true}
                    ref={elRef}
                    {...otherProps}
                ></iframe>
            </div>
        );
    };

    return render();
}
